import { BaseAccordionUIChild } from './BaseAccordionUIChild';

export class BaseAccordionUIRoot {
  constructor() {
    this.elements = document.querySelectorAll('[data-base-accordion-ui]');

    if (!this.elements.length) {
      return;
    }

    this.init();
  }

  init() {
    this.elements.forEach((el) => new BaseAccordionUIChild(el));
  }
}
